import React, { FC, MouseEventHandler, MouseEvent } from 'react'
import './index.scss'
import LazyLoad from 'react-lazyload'

const fontWeight = {
  fontWeight: 900,
  REGULAR: 'normal',
  SEMIBLOD: 'bold'
}
export interface CombinationProps {
  combination: {
    wdId: string
    dataType: string
    viewTypeV2: string
    card: { [key: string]: any }
  }
  pid: string
  clickTo: (
    componentType?: string,
    combinationId?: string,
    deeplink?: string,
    componentId?: string
  ) => void
}

const Combination: FC<CombinationProps> = ({ combination, clickTo, pid }) => {
  const { card = {}, wdId = '' } = combination

  const handleCombinationClick: MouseEventHandler = () => {
    clickTo('combination', wdId, card?.deeplink, pid)
  }

  return (
    <div className="by-combination" onClick={handleCombinationClick}>
      <div className="by-combination-header">
        <div
          className="title-img"
          style={{ backgroundImage: `url(${card?.title?.badge?.image?.url})` }}
        ></div>
        <div className="combination-info">
          <div className="combination-name">
            {card?.title?.texts?.map((item) => (
              <span
                style={{
                  color: `#${item.color}`,
                  fontWeight: fontWeight[item.fontWeight] || 'blod',
                }}
              >
                {item.text}
              </span>
            ))}
          </div>
          <div className="combination-tip">
            {card?.subTitle?.texts?.map((item) => (
              <span style={{ color: `#${item.color}` }}>{item.text}</span>
            ))}
          </div>
        </div>
        <button className="combination-btn">
          {card?.title?.linkButton?.title}
        </button>
      </div>
      <ul className="combination-product-list">
        {card?.items?.map((item) => (
          <li>
            <LazyLoad>
              <img src={item?.image.url} />
            </LazyLoad>
          </li>
        ))}
      </ul>
      <div className="combination-footer">
        {card?.footer?.texts?.map((item) => (
          <span style={{ color: `#${item.color}` }}>{item.text}</span>
        ))}
      </div>
    </div>
  )
}

export default Combination